<template>
    <v-flex xs12>
      <v-card>
        <v-flex xs12 px-4 pt-4 v-if="err">
          <v-alert :value="true" type="error">{{err}}</v-alert>
        </v-flex>
        <v-card-title class="pb-3 px-2 layout row wrap">
          <v-btn class="primary my-0 mx-3" @click='$router.push({ name: "tableCategoryCreate" })'>Create New Table Category</v-btn>
          <v-checkbox
            color="primary"
            class="mx-1 mt-0"
            :label="$lang.labels.showActive"
            v-model="showActive"
            hide-details
          />
          <v-spacer />
          <v-autocomplete
            v-if="!isLocalAdmin"
            class="min-w max-w mx-3 pb-2"
            :label="$lang.actions.selectCompany"
            :items="mappedCompanies"
            :loading="companyLoading"
            v-model="selectedCompany"
            hide-details
          />
          <v-text-field
            v-if="show"
            class="min-w max-w mx-3 pb-2"
            v-model="search"
            append-icon="search"
            :label="$lang.labels.search"
            hide-details
          />
        </v-card-title>
        <v-data-table
          v-if="show"
          :headers="headers"
          :items="showActive ? activeTableCategories : allTableCategories"
          :search="search"
          :loading="loading"
          :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
        >
          <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name[language] }}</td>
            <td>{{ props.item.sequenceNumber }}</td>
            <td class="text-xs-left">{{ props.item.status }}</td>
            <td class="text-xs-left min-w-lg">
              <v-btn class="primary mx-0 elevation-1" @click="$router.push({ name: 'tableCategoryUpdate', params: { id: props.item.id } })">{{$lang.actions.edit}}</v-btn>
              <v-btn class="primary elevation-1" @click="changeStatus(props.item)">{{props.item.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}</v-btn>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="warning" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    data() {
      return {
        err: '',
        search: '',
        show: false,
        loading: true,
        language: this.$cookie.get('lang') || 'en',
        companies: [],
        selectedCompany: '',
        companyLoading: true,
        headers: [
          { text: this.$lang.labels.name, value: 'name', align: 'left' },
          { text: this.$lang.labels.sequenceNumber, value: 'sequenceNumber', align: 'left' },
          { text: this.$lang.labels.status, value: 'status', align: 'left' },
          { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false },
        ],
        showActive: true,
        allTableCategories: [],
        isLocalAdmin: false,
      }
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
      selectedCompany(val) {
        this.fetchTableCategoriesforCompany(val);
        this.$cookie.set('companyedit', val, { expires: '8h' });
      },
    },
    computed: {
      activeTableCategories() {
        const tableCategories = this.allTableCategories;
        const activeTableCategories = [];
        for (let i=0; tableCategories.length > i; i++) {
          if (tableCategories[i].status === 'active') {
            activeTableCategories.push(tableCategories[i]);
          }
        }
        return activeTableCategories;
      },
      mappedCompanies() {
        return this.companies.map(company => ({
          text: `${company.name} (${company.companyStatus})`,
          value: company.id,
        }));
      },
    },
    methods: {
      init() {
        return new Promise((resolve) => {
            this.$http.get('company')
            .then((res) => {
              resolve()
              this.companyLoading = false;
              if (res.body.status === 'Success') {
                this.companies = res.body.companies;
                if (this.isLocalAdmin) this.selectedCompany = res.body.companies[0].id;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve()
              this.companyLoading = false;
              this.err = err.body.statusText || err.body.message;
            });
        });
      },
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd');
      },
      changeStatus(category) {
        const action = category.status === 'active' ? 'deactivate' : 'activate';
        this.$http.post(`tablecategory/${action}/${category.id}`)
        .then((res) => {
          if (res.body.status === 'Success') {
            this.$set(category, 'status', action === 'activate' ? 'active' : 'inactive');
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      },
      fetchTableCategoriesforCompany(id) {
        this.show = true;
        this.allTableCategories = [];
        this.activeTableCategories = [];
        this.$http.post('tablecategory/getall', { companyId: id })
        .then((res) => {
          this.loading = false;
          if (res.body.status === 'Success') {
            this.allTableCategories = res.body.details;
            return;
          }
          if (this.tableCategories.length === 0) {
            this.loading = false;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.loading = false;
          this.err = err.body.statusText || err.body.message;
        });
      },
    },
    created() {
      this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
      if (this.isLocalAdmin) {
        this.fetchTableCategoriesforCompany();
        return;
      }

      this.init()
        .then(() => {
          const edit = this.$cookie.get('companyedit');
          if (edit) this.selectedCompany = edit;
        });
    },
  };
</script>



// WEBPACK FOOTER //
// TableCategories.vue?ed3316e4